import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

export const MARGINS_NAME_COLUMN_WIDTH = 274;

export function marginsStandardColumnWidth(theme: Theme): string {
  return theme.spacing(10);
}

export function marginsPayRangeColumnSx(
  theme: Theme,
): SystemStyleObject<Theme> {
  const w = theme.spacing(13);
  return {
    width: w,
    minWidth: w,
    maxWidth: w,
    textAlign: 'center',
  };
}

export function marginsPayRangeBodyCellSx(
  theme: Theme,
): SystemStyleObject<Theme> {
  return {
    ...marginsPayRangeColumnSx(theme),
    borderBottom: 0,
    verticalAlign: 'middle',
  };
}

export function marginsActionsColumnSx(theme: Theme): SystemStyleObject<Theme> {
  const w = theme.spacing(12);
  return {
    width: w,
    minWidth: w,
    maxWidth: w,
    px: 0.25,
    py: 0,
    verticalAlign: 'middle',
    textAlign: 'center',
    boxSizing: 'border-box',
  };
}

export function marginsActionsColumnBodySx(
  theme: Theme,
): SystemStyleObject<Theme> {
  return {
    ...marginsActionsColumnSx(theme),
    borderBottom: 0,
  };
}
